/**
 * The page's side of the bridge to the Finpilot Notetaker app (#9163): what
 * `react-native-webview` puts on the page it hosts. The app reads every
 * message in its `src/web/shell.ts` (`parseShellMessage`).
 */

/** What `react-native-webview` puts on the page it hosts. */
interface ReactNativeWebViewBridge {
  postMessage(data: string): void;
}

/** The app's bridge, or null outside the app's web view. */
function webViewBridge(): ReactNativeWebViewBridge | null {
  const bridge = (window as { ReactNativeWebView?: ReactNativeWebViewBridge })
    .ReactNativeWebView;
  return bridge && typeof bridge.postMessage === "function" ? bridge : null;
}

/** Sends `message` to the app as JSON; nothing outside the app's web view. */
export function postToApp(message: { type: string }): void {
  webViewBridge()?.postMessage(JSON.stringify(message));
}

/** Asks the app to record a calendar meeting (a Coming up row's tap). */
export const START_RECORDING_MESSAGE_TYPE = "fp:start-recording";

/**
 * The meeting the app records, in the wire shape of the calendar read; the
 * app creates its server meeting from these fields as the desktop app does.
 * `timezone` is the event's stated zone, else the viewer's.
 */
export interface StartRecordingMessage {
  type: typeof START_RECORDING_MESSAGE_TYPE;
  meeting: {
    event_id: string;
    title: string;
    meeting_url: string | null;
    attendees: string[];
    attendee_names: string[];
    start_time: string;
    end_time: string;
    timezone: string | null;
  };
}
